import { render, staticRenderFns } from "./SignInModern.vue?vue&type=template&id=b2ee8256&scoped=true"
import script from "./SignInModern.vue?vue&type=script&lang=js"
export * from "./SignInModern.vue?vue&type=script&lang=js"
import style0 from "./SignInModern.vue?vue&type=style&index=0&id=b2ee8256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ee8256",
  null
  
)

export default component.exports